// 公众号授权接口
import axios from '@/api/config';
const empower = {
    processAuthorizeEventScanUrl(params) {
        return axios.get(`${process.env.BASE_URL}/wx/wp/processAuthorizeEventScanUrl`, { params });
    },
    agentAppRelevance(params) {
        return axios.get(`${process.env.BASE_URL}/wx/wp/agent_app_relevance`, { params });
    },
}
export default empower


// WEBPACK FOOTER //
// ./src/api/empower.js